"use strict";

import http from "@/http";

const BASE_NAME = "/email-signatures";

const list = async () => (await http.get(BASE_NAME)).data;
const create = async signature => (await http.post(BASE_NAME, signature)).data;
const edit = async (id, signature) => (await http.put(`${BASE_NAME}/${id}`, signature)).data;
const remove = async id => { await http.delete(`${BASE_NAME}/${id}`); };

export default { list, create, edit, remove };
